
import {Component, Vue} from "vue-property-decorator";
import KeyStatus from "@/components/keys/KeyStatus.vue";
import RelayGiveKeyToGuest from "@/components/relays/RelayGiveKeyToGuest.vue";
import MobileListKeyItem from "@/components/mobile/MobileListKeyItem.vue";
import {Getter} from "vuex-class";
import RelayBookedKey from "@/components/relays/RelayBookedKey.vue";

// Number of items loaded with infinite scroll
const ITEMS_PER_PAGE: number = 20;

@Component({
    components: {
        RelayGiveKeyToGuest,
        KeyStatus,
        MobileListKeyItem,
        RelayBookedKey,
    },
})
export default class RelayKeysMobile extends Vue {

    @Getter private currentUser: any;

    private loading: boolean = true;
    private keys: any[] = [];
    private search: string = "";
    private pagination: any = {
        sortDesc: [true],
        sortBy: ["updatedAt"],
        search: "",
        select: [],
        page: 1,
        itemsPerPage: ITEMS_PER_PAGE,
    };
    private totalKeys: number = 0;

    get allKeysFetch(): boolean {
        return this.totalKeys === this.keys?.length;
    }

    private mounted() {
        this.initScroll();
        this.fetchFirstKeys();
    }

    private relayDisplayed(key): any {
        return key.Relays?.find((relay) => relay.type === "AGENCY")
            || key.Relays?.[0];
    }

    private getKeys(): Promise<any> {
        this.loading = true;
        this.pagination.search = this.search;
        return this.$store.dispatch("users/getKeysOutIn", {
            id: this.currentUser.id,
            query: this.pagination,
        }).then((res: any) => {
            res?.rows?.forEach((key: any) => {
                // Display either current location or reserved location if the key is not in relay
                key.locationDisplayed = key.currentLocation || key.ReservedLocations?.[0];
            });
            this.totalKeys = res?.count || 0;
            return res;
        }).finally(() => {
            this.loading = false;
        });
    }

    private async fetchFirstKeys(): Promise<void> {
        this.pagination.page = 1;
        this.keys = [];
        return this.getKeys().then((res: any) => {
            this.keys = res.rows;
        });
    }

    private fetchNextKeys(): Promise<void> {
        this.pagination.page += 1;
        return this.getKeys().then((res: any) => {
            this.keys = [
                ...this.keys,
                ...res.rows,
            ];
        });
    }

    private initScroll(): void {
        window.onscroll = async (): Promise<void> => {
            const listElm = document.querySelector(".scroll-list");
            const currentScrollValue: number = document.documentElement.scrollTop;
            const threshold: number = listElm?.clientHeight - window.innerHeight - 1000;
            const isTargetPos: boolean = currentScrollValue > threshold;
            if (isTargetPos && !this.loading && !this.allKeysFetch) {
                await this.fetchNextKeys();
            }
        };
    }

    // Function used calling $ref in parent component (@TODO: change this)
    private findKeysBySearch(search: string) {
        this.search = search;
        this.fetchFirstKeys();
    }
}
